import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class extends Controller {
  static targets = ["media", "text", "wrapper"];

  connect() {
    if (!this.hasWrapperTarget || !this.hasTextTarget || !this.hasMediaTarget) {
      console.warn("Hero pinned parallax: missing required targets", {
        wrapper: this.hasWrapperTarget,
        text: this.hasTextTarget,
        media: this.hasMediaTarget,
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    this.textTarget.style.willChange = "transform, opacity";
    this.mediaTarget.style.willChange = "transform";

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.wrapperTarget,
        pin: true,
        start: "top top",
        end: "+=130%", // Augmenter cette valeur pour augmenter la durée de l'animation du texte
        scrub: 1,
        invalidateOnRefresh: true,
      },
    });
    tl.to(this.textTarget, {
      opacity: 1,
      y: "-10vh", // Cette valeur définit à quelle hauteur dans le viewport le texte est en opacité 1
      ease: "power4.in",
      duration: 0.15, // Cette valeur (avec la duration ci-dessous) définit quelle proportion de l'animation est utilisée pour passer le texte en opacité 1
    });
    tl.to(this.textTarget, {
      y: "-120vh",
      ease: "none",
      duration: 0.45, // Cf. ci-dessus. Ici, c'est la proportion de l'animation pour que le texte sorte de l'écran par le haut. ATTENTION : valeur max des deux duration à 1.
    });
    const tlMedia = gsap.timeline({
      scrollTrigger: {
        trigger: this.wrapperTarget,
        start: "top+45% top",
        end: "bottom top",
        scrub: true,
      },
    });
    tlMedia.to(this.mediaTarget, {
      y: "30vh", // Cette valeur définit la vitesse de la parallaxe de la vidéo une fois que le scroll normal a repris
      ease: "none",
    });
  }

  disconnect() {
    if (this.hasTextTarget) {
      this.textTarget.style.willChange = "auto";
    }
    if (this.hasMediaTarget) {
      this.mediaTarget.style.willChange = "auto";
    }
  }
}
